import { useMemo } from 'react';
import { useObservableState } from 'observable-hooks';
import { useTheme } from '@mui/material';
import { ProcomSettings } from '../config';
import { PaletteModeCode } from '../enums';
import { getVendorCode } from '../util';
import { useClientService } from './use-services';
export var useClientLogo = function() {
    var _clientSettings_common_logo, _clientSettings_common_logo1;
    var theme = useTheme();
    var clientService = useClientService();
    var clientSettings = useObservableState(clientService.clientSetting$, ProcomSettings);
    var _clientSettings_common_logo_assetClient;
    var clientCode = (_clientSettings_common_logo_assetClient = clientSettings === null || clientSettings === void 0 ? void 0 : (_clientSettings_common_logo = clientSettings.common.logo) === null || _clientSettings_common_logo === void 0 ? void 0 : _clientSettings_common_logo.assetClient) !== null && _clientSettings_common_logo_assetClient !== void 0 ? _clientSettings_common_logo_assetClient : clientSettings === null || clientSettings === void 0 ? void 0 : clientSettings.common.name;
    var themePalette = useMemo(function() {
        if (theme.palette.logoMode) {
            return theme.palette.logoMode;
        }
        if (theme.palette.mode === PaletteModeCode.light) {
            return 'light';
        }
        return 'dark';
    }, [
        theme.palette.mode,
        theme.palette.logoMode
    ]);
    var vendorCode = getVendorCode();
    return useMemo(function() {
        var _clientSettings_common_logo;
        if (clientSettings === null || clientSettings === void 0 ? void 0 : (_clientSettings_common_logo = clientSettings.common.logo) === null || _clientSettings_common_logo === void 0 ? void 0 : _clientSettings_common_logo.imgExtension) {
            var _clientSettings_common_logo1;
            return "/assets/vendors/".concat(vendorCode, "/").concat(clientCode, "/logo-").concat(themePalette, ".").concat(clientSettings === null || clientSettings === void 0 ? void 0 : (_clientSettings_common_logo1 = clientSettings.common.logo) === null || _clientSettings_common_logo1 === void 0 ? void 0 : _clientSettings_common_logo1.imgExtension);
        }
        return "/assets/vendors/".concat(vendorCode, "/").concat(clientCode, "/logo-").concat(themePalette, ".svg#default");
    }, [
        clientCode,
        clientSettings === null || clientSettings === void 0 ? void 0 : (_clientSettings_common_logo1 = clientSettings.common.logo) === null || _clientSettings_common_logo1 === void 0 ? void 0 : _clientSettings_common_logo1.imgExtension,
        themePalette,
        vendorCode
    ]);
};
